module.exports = __webpack_public_path__ + "static/media/5_ES.5340440b.mp3";